export default __webpack_public_path__ + "static/media/start_DE.da09a2ab.png";